module.exports = __webpack_public_path__ + "img/not-found.f8367908.png";